import * as React from 'react';

import { createIcon } from '../Icon';
export const MinusSquareIcon = createIcon(
  <React.Fragment>
    <rect height={18} rx={2} ry={2} width={18} x={3} y={3} />
    <line x1={8} x2={16} y1={12} y2={12} />
  </React.Fragment>,
  'MinusSquareIcon'
);
